import { ref, isRef, type Ref } from 'vue';
import { useElementVisibility, watchOnce } from '@vueuse/core';

/** 定位到某元素顶部 **/
const getElementToPageTop = (el: HTMLElement | null): number => {
  if (!el) {
    return 0;
  }
  if (el.parentElement) {
    return getElementToPageTop(el.parentElement) + el.offsetTop;
  }
  return el.offsetTop;
}

export const getOffSetTop = (el: Ref<HTMLElement | null>): number => {
  if (!isRef(el)) {
    return 0;
  }
  const topValue = getElementToPageTop(el.value);
  return topValue;
}

export const useElementVisibilityOnce = (elementRef: Ref) => {
  const isVisible = ref(false);
  const isElementVisible = useElementVisibility(elementRef);

  watchOnce(isElementVisible, (value) => {
    if (value === true) {
      isVisible.value = true;
    }
  });

  return isVisible;
}

// 执行 PV 统计
export const statsPv = () => {
  if (window._oafs) {
    window._oafs.setDefault('pageId',  document.title);
    window._oafs.pv();
  }
}
